import { number } from 'mathjs';

export const extract_bags = (bags) => bags.split('|');

export const collapse_bags = (bags) => bags.join('|');

export const encode_bag_info = (bag_info) =>
  [
    `${bag_info.quantity || 1}`,
    `${String(bag_info.weight || '')}${bag_info.weight ? bag_info.weightUnit || 'kg' : ''}`,
  ]
    .filter((e) => e.length !== 0)
    .join(':');

export const decode_bag_info = (bag_info) => {
  try {
    if (String(bag_info).length > 0) {
      const parts = String(bag_info).split(':');
      return {
        quantity: number(parts.length > 0 ? parts[0] : 1),
        weight: parts.length > 1 ? parts[1] : undefined,
      };
    }
  } catch {
    // EMPTY
  }
  return { quantity: 1, weight: undefined };
};

export const find_bag_id = (
  flexible_bags,
  traveler_index,
  itinerary_index,
  quantity = 1,
  weight = undefined
) => {
  if (traveler_index < 0) {
    return '-1';
  }
  const traveler_bags = Object.values(flexible_bags[traveler_index]);
  const bags = Object.entries(traveler_bags[itinerary_index]);

  for (let index = 0; index < bags.length; index++) {
    const entry = bags[index];
    const bag = entry[1].bag;
    const quantity_check = (bag.quantity || 1) === quantity;
    const weight_check = (!weight && !bag.weight) || bag.weight === weight;
    if (quantity_check && weight_check) {
      return entry[0];
    }
  }
  return '-1';
};
